import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Modal,
    Transfer,
    message,
    Divider,
    Rate,
    Popover
} from 'antd';
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import {CloseOutlined} from '@ant-design/icons'
import moment from 'moment';
import HtView from '../hetong/view'
import Jfjl from "./jfjl";

const {Search} = Input;
const {Option} = Select;
const {RangePicker} = DatePicker;

class DwView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {},
            visible: false,
        };
        this.mingpian = React.createRef();
        this.genjin = React.createRef();
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {


    }

    mdchange() {
        let that = this
        let visible = !that.state.visible
        that.setState({
            visible
        })
        if (visible) {
            that.getdata()
        } else {
            that.setState({
                condition: {},
            })
        }
    }

    getdata() {
        let that = this
        let arr = {}
        arr.id = that.props.id
        fetch('/Company/detail', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                that.setState({
                    condition: data.data
                })
            })
    }

    arrfjlist(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <div key={index}>
                    <a href={item.url} download={item.name}>
                        {item.name}
                    </a>
                </div>
            )
        }
    }

    arrRych(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Tag color={'blue'}>{item}</Tag>
            )
        }
    }

    render() {
        const columns = [
            {
                title: '合同编号',
                dataIndex: 'ref',
                key: 'ref',
                width: 150,
            }, {
                title: '签约时间',
                dataIndex: 'qytime',
                key: 'qytime',
            }, {
                title: '租赁时间',
                dataIndex: 'stime',
                key: 'stime',
                width: 120,
            }, {
                title: '合同状态',
                dataIndex: 'status',
                key: 'status',
                width: 100,
                render: (row, record) => {
                    return (<>
                        {row == 1 ? <Tag color={'green'}>{record.status_text}</Tag> : null}
                        {row == 2 ? <Tag color={'red'}>{record.status_text}</Tag> : null}
                    </>)
                },
            }, {
                title: '操作',
                dataIndex: 'cz',
                key: 'cz',
                align: 'center',
                fixed: 'right',
                width: 100,
                render: (row, record) => {
                    return (<>
                        <Space>
                            <HtView id={record.id} title={"查看"} refresh={() => {
                            }}/>
                        </Space>
                    </>)
                },
            },]
        const columns3 = [
            {
                title: '所属园区',
                dataIndex: 'yq_id',
                key: 'yq_id',
            }, {
                title: '楼栋',
                dataIndex: 'building',
                key: 'building',
            }, {
                title: '房间号',
                dataIndex: 'number',
                key: 'number',
            }, {
                title: '面积',
                dataIndex: 'area',
                key: 'area',
            }]
        return (
            <>
                {this.props.title ?
                    <a href='javascript:void(0)' type="link" onClick={this.mdchange.bind(this)}>{this.props.title}</a> :
                    <a href='javascript:void(0)' type="link" onClick={this.mdchange.bind(this)}>查看</a>}

                <Modal title="查看详情" destroyOnClose={true} bodyStyle={{padding: 15}} width={800}
                       visible={this.state.visible} onCancel={this.mdchange.bind(this)} footer={null}>
                    <div className={'view_box'}>
                        <div className={'view_title'}>企业信息</div>
                        <div className={'view_info'}>
                            <div className={'item'}>
                                <div className={'p1'}>企业名称</div>
                                <div className={'p2'}>{this.state.condition.name}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>统一社会信用代码</div>
                                <div className={'p2'}>{this.state.condition.creditCode}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>所属园区</div>
                                <div className={'p2'}>{this.state.condition.yq_id}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>房间号</div>
                                <div className={'p2'}>{this.state.condition.room}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>曾用名</div>
                                <div className={'p2'}>{this.state.condition.aliasname}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>企业简称</div>
                                <div className={'p2'}>{this.state.condition.qyjc}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>法定代表人</div>
                                <div className={'p2'}>{this.state.condition.corporation}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>成立时间</div>
                                <div className={'p2'}>{this.state.condition.regtime}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>注册资本</div>
                                <div className={'p2'}>{this.state.condition.regcapital}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>企业类型</div>
                                <div className={'p2'}>{this.state.condition.type}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>企业行业</div>
                                <div className={'p2'}>{this.state.condition.industry}</div>
                            </div>
                            <div className={'item all'}>
                                <div className={'p1'}>注册地址</div>
                                <div className={'p2'}>{this.state.condition.reglocation}</div>
                            </div>
                            <div className={'item all'}>
                                <div className={'p1'}>荣誉称号</div>
                                <div className={'p2'}>
                                    <Space wrap size={0}>
                                        {this.arrRych(this.state.condition.honor)}
                                    </Space>
                                </div>
                            </div>
                            <div className={'item all'}>
                                <div className={'p1'}>主营业务</div>
                                <div className={'p2'}>
                                    <div
                                        dangerouslySetInnerHTML={{__html: this.state.condition.business}}></div>
                                </div>
                            </div>
                            <div className={'item all'}>
                                <div className={'p1'}>企业附件</div>
                                <div className={'p2'}>
                                    <Space wrap direction={"vertical"}>
                                        {this.arrfjlist(this.state.condition.fjlist)}
                                    </Space>
                                </div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>招商负责人</div>
                                <div className={'p2'}>{this.state.condition.zs_fzr}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>招商部门</div>
                                <div className={'p2'}>{this.state.condition.zs_bumen}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>日常联系人</div>
                                <div className={'p2'}>{this.state.condition.contacts}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>日常联系人电话</div>
                                <div className={'p2'}>{this.state.condition.phone}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>紧急联系人</div>
                                <div className={'p2'}>{this.state.condition.emcontacts}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>紧急联系人电话</div>
                                <div className={'p2'}>{this.state.condition.emphone}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>入驻状态</div>
                                <div className={'p2'}>
                                    {this.state.condition.status == 1 &&
                                        <span style={{color: '#1890ff'}}>{this.state.condition.status_text}</span>}
                                    {this.state.condition.status == 2 &&
                                        <span style={{color: 'red'}}>{this.state.condition.status_text}</span>}
                                </div>
                            </div>
                        </div>
                        {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('1') ? <>
                            <div className={'view_title'}>合同信息</div>
                            <Table
                                bordered
                                columns={columns}
                                dataSource={this.state.condition.contract}
                                pagination={false}
                                style={{width: '100%'}}
                            />
                        </> : null) : null}
                        <div className={'view_title'}>房间信息</div>
                        <Table
                            bordered
                            columns={columns3}
                            dataSource={this.state.condition.room_list}
                            pagination={false}
                            style={{width: '100%'}}
                        />
                        <Jfjl id={this.props.id}/>
                    </div>
                </Modal>
            </>
        )
    }
}

export default DwView
